import React from 'react';
import PropTypes from 'prop-types';

const SettingCheckbox = ({
  name,
  isChecked,
  text,
  onChange
}) => {
  return (
    <>
      <input
          type="checkbox"
          name={name}
          checked={isChecked}
          onChange={onChange}
      />
      <label htmlFor={name}>{text}</label>
    </>
  );
};

SettingCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default SettingCheckbox;
